import { AsyncPipe, NgForOf, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseFooterController, FooterNavModule, LinkModule, SocialLinksModule, UtilsModule } from '@ncg/ui';
import { IconSpriteModule } from 'ng-svg-icon-sprite';

@Component({
    selector: 'ncg-footer',
    template: `
        <footer class="footer">
            <ng-container *ngIf="navigationService.getNavigation() | async as items">
                <ng-container *ngIf="items | filter: 'includeInFooter' as footerItems">
                    <ncg-footer-nav class="section footer-top" [items]="footerItems" *ngIf="footerItems?.length"></ncg-footer-nav>
                </ng-container>
            </ng-container>

            <div class="section footer-bottom" *ngIf="settingsService.get() | async as settings">
                <div class="container">
                    <div class="footer-bottom__logo">
                        <svg-icon-sprite
                            src="byd-logo"
                            [viewBox]="'0 0 94 18'"
                            [width]="'100px'"
                            [height]="'20px'"
                            aria-hidden="true"></svg-icon-sprite>
                    </div>
                    <ncg-social-links
                        *ngIf="settings.socialLinks"
                        class="footer-bottom__social"
                        [socialLinks]="settings.socialLinks"></ncg-social-links>
                    <div class="footer-bottom__links" *ngIf="settings.footerLinks.length">
                        <nav class="footer-bottom__navbar navbar">
                            <ncg-link *ngFor="let link of settings.footerLinks" [link]="link" styleClass="footer-bottom__item navbar-item"></ncg-link>
                        </nav>
                    </div>
                    <div class="footer-bottom__copyright" *ngIf="settings.copyright">
                        {{ settings.copyright }}
                    </div>
                </div>
            </div>
        </footer>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, FooterNavModule, IconSpriteModule, LinkModule, NgForOf, NgIf, SocialLinksModule, UtilsModule],
})
export class FooterComponent extends BaseFooterController {}
